module.exports = __webpack_public_path__ + "img/avatar.300c7adf.png";